// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"300":"bf4cbe7a","856":"dceae72d","864":"cd81588a","952":"e050f50b"}[chunkId] + ".chunk.js";
};